import { AnalyticsEventData } from 'idt-analytics-api/models';
import { CategoriesHelpers } from 'idt-ecommerce-api/catalog/categories/categories.helpers';
import { AnalyticsPageData } from '../models/brand-analytics.models';
import { AnalyticsHelpersOysho } from './brand-analytics.helpers.oy';

export const pageTypes = new Map<string, AnalyticsPageData>([
  ['index', {
    section: 'entrada',
    pageType: 'home',
    pageTitle: 'pagina_inicio',
    dimensions: ['1', '2', '11', '12', '63', '67', '73', '90', '92']
  }],
  ['grid', {
    section: 'catalogo',
    pageType: 'parrilla',
    pageTitle: (data) => gridTitle(data),
    ecommerce: 'impressions',
    dimensions: ['16', '17', '19', '198', '64', '71', '72', '67', '90', '63'],
    isFromComponent: true
  }],
  ['product', {
    section: 'ficha_de_producto',
    pageType: 'ficha_producto',
    pageTitle: (data) => productTitle(data),
    ecommerce: 'detail',
    dimensions: ['63', '67', '90', '100', '101', '108', '110', '112', '117', '15', '16', '17',
      '198', '20', '47', '48', '70', '71', '72', '74', '93', '98', '99', '22'],
    isFromComponent: true
  }],
  ['colbenson', {
    section: 'catalogo',
    pageType: 'buscador',
    pageTitle: (data) => colbensonSearcherTitle(data),
    dimensions: ['24', '49', '90', '63', '67'],
    isFromComponent: true
  }],
  ['store-locator', {
    section: 'localizador_tiendas',
    pageType: 'localizar',
    pageTitle: 'buscador',
    dimensions: ['67', '63', '90']
  }],
  ['store-locator-city', {
    section: 'localizador_tiendas',
    pageType: 'localizar',
    pageTitle: 'ciudad',
    dimensions: ['67', '63', '90']
  }],
  ['store-locator-store', {
    section: 'localizador_tiendas',
    pageType: 'localizar',
    pageTitle: 'mapa',
    dimensions: ['67', '63', '83', '90']
  }],
  ['store-locator-list', {
    section: 'localizador_tiendas',
    pageType: 'localizar',
    pageTitle: 'lista',
    dimensions: ['13', '67', '63', '90']
  }],
  ['store-booking', {
    section: 'catalogo',
    pageType: 'reserva_en_tienda',
    pageTitle: (data) => storeBookingTitle(data),
    dimensions: ['67', '63', '90', '108', '110', '112', '15', '16', '17', '198', '20', '71', '72', '74', '93', '98']
  }],
  ['store-booking-bundle', {
    section: 'catalogo',
    pageType: 'reserva_en_tienda',
    pageTitle: (data) => storeBookingBundleTitle(data),
    dimensions: ['67', '63', '90', '15', '16', '17', '198', '65', '71', '72', '74', '93']
  }],
  ['worldwide', {
    section: 'entrada',
    pageType: 'worldwide',
    pageTitle: 'seleccion_tienda_e_idioma',
    dimensions: ['63', '67', '90']
  }],
  ['cross-product-rapid-view', {
    section: 'catalogo',
    pageType: 'vista_rapida_producto_cross',
    pageTitle: (data) => vistaRapidaProductCrossTitle(data),
    ecommerce: 'detail',
    isFromComponent: true,
    dimensions: ['100', '101', '108', '110', '112', '117', '139', '15', '16', '17', '90',
      '198', '20', '47', '48', '70', '71', '72', '74', '93', '98', '99', '67', '63']
  }],
  ['user', {
    section: 'perfil_usuario',
    pageType: 'acceso',
    pageTitle: 'login',
    isFromComponent: true,
    dimensions: ['63', '67', '90']
  }],
  ['mini-shopcart', {
    section: 'checkout',
    pageType: 'minicesta',
    pageTitle: 'lista_de_productos',
    isFromComponent: true,
    dimensions: ['63', '67', '90']
  }],
  ['mini-wishlist', {
    section: 'catalogo',
    pageType: 'miniwishlist',
    isFromComponent: true,
    dimensions: ['63', '67', '90']
  }],
  ['session-expired', {
    section: 'perfil_usuario',
    pageType: 'sesion_expirada',
    isFromComponent: true,
    dimensions: ['63', '67', '90']
  }],
  ['redirect-to-ww', {
    section: 'catalogo',
    pageType: 'ficha_producto',
    pageTitle: (data) => moreInfoWWTitle(data),
    isFromComponent: true,
    dimensions: ['63', '67', '90', '20']
  }],
  ['reset-password', {
    section: 'checkout',
    pageType: 'acceso',
    pageTitle: 'recuperar_contrasena',
    isFromComponent: true,
    dimensions: ['63', '67', '90']
  }],
  ['generic-error', {
    section: 'error',
    pageType: 'generic_error',
    dimensions: ['63', '67', '90']
  }],
  ['contact', {
    section: 'ayuda',
    pageType: 'contacto',
    dimensions: ['63', '67', '90']
  }],
  ['company-contact', {
    section: 'ayuda',
    pageType: 'contacto',
    pageTitle: 'formulario_contacto/tienda_empresa',
    dimensions: ['63', '67', '90']
  }],
  ['online-contact', {
    section: 'ayuda',
    pageType: 'contacto',
    pageTitle: 'formulario_contacto/venta_online',
    dimensions: ['63', '67', '90']
  }],
  ['shopcart', {
    section: 'checkout',
    pageType: 'cesta',
    pageTitle: 'lista_de_productos',
    isFromComponent: true,
    dimensions: ['63', '67', '90', '31', '32', '51', '52', '53', '133'],
    ecommerce: 'add',
  }],
  ['company', {
    section: 'corporativo',
    pageType: 'empresa',
    pageTitle: 'datos_empresa',
    dimensions: ['63', '67', '90']
  }],
  ['landing-guiatallas', {
    section: 'ayuda',
    pageType: 'guia_tallas',
    dimensions: ['63', '67', '90']
  }],
  ['help-center', {
    section: 'centro_de_ayuda',
    pageType: 'ayuda_al_usuario',
    dimensions: ['63', '67', '90']
  }],
  ['policies', {
    section: 'legal',
    pageType: 'politicas',
    dimensions: ['63', '67', '90']
  }],
  ['press', {
    section: 'corporativo',
    pageType: 'prensa',
    pageTitle: 'datos_contacto',
    dimensions: ['63', '67', '90']
  }],
  ['oysho-wallet', {
    section: 'catalogo',
    pageType: 'landing',
    pageTitle: 'landing_oysho-wallet',
    dimensions: ['63', '67', '90']
  }],
  ['e-ticket', {
    section: 'catalogo',
    pageType: 'landing',
    pageTitle: 'landing_e-ticket',
    dimensions: ['63', '67', '90']
  }],
  ['find-your-fit', {
    section: 'catalogo',
    pageType: 'find_your_fit',
    pageTitle: 'parrilla_find_your_fit',
    ecommerce: 'impressions',
    dimensions: ['15', '16', '17','198', '71', '72', '67', '90', '63'],
  }],
]);

const gridTitle = (data: AnalyticsEventData): string | undefined => {
  const { componentData, context } = data;
  let pageTitle;

  if (componentData?.categoryId && context?.categories) {
    const flatCategories = CategoriesHelpers.flatCategoriesMap(context.categories);
    const categoriesPath = flatCategories[componentData?.categoryId]?.sectionPathEn;
    pageTitle = categoriesPath ? AnalyticsHelpersOysho.parsePath(categoriesPath) : undefined;
  }

  return pageTitle;
};

const productTitle = (data: AnalyticsEventData): string | undefined => {
  const { componentData } = data;
  const product = componentData.products?.[0];
  let pageTitle;

  if (isDefined(product)) {
    const partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    pageTitle = `${partnumber}/detalles_producto`;
  }


  return pageTitle;
};

const colbensonSearcherTitle = (data: AnalyticsEventData): string | undefined => `resultados/lista?q=${data?.componentData?.buttonText}`;

const vistaRapidaProductCrossTitle = (data: AnalyticsEventData): string | undefined => {
  const { componentData } = data;
  const product = componentData.products?.[0];
  let pageTitle;

  if (isDefined(product)) {
    const partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    pageTitle = `${partnumber}/detalles_producto`;
  }

  return pageTitle;
};

const storeBookingBundleTitle = (data: AnalyticsEventData): string | undefined => {
  let title: string | undefined;
  if(data?.componentData?.products) {
    title = `${data?.componentData?.products[0]?.fullReference}/reserva`;
  }
  return title;
};

const storeBookingTitle = (data: AnalyticsEventData): string | undefined => {
  const { componentData } = data;
  const product = componentData.products?.[0];
  let pageTitle;

  if (isDefined(product)) {
    const partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    pageTitle = `${partnumber}/reserva`;
  }

  return pageTitle;
};

const moreInfoWWTitle = (data: AnalyticsEventData): string | undefined => {
  const { componentData } = data;
  const product = componentData.products?.[0];
  let pageTitle;

  if (isDefined(product)) {
    const partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    pageTitle = `${partnumber}/more_info/worldwide`;
  }

  return pageTitle;
};
